import theme from '../theme/theme';

/**
 * Unified agent type configuration map.
 * Each agent type has a label, color, and monitoring flag.
 */
export const AGENT_TYPE_CONFIG = {
  'media-buy': { label: 'Media Buy', color: theme.colors.CORE, isMonitoring: false },
  seller: { label: 'Seller', color: theme.colors.PLUM, isMonitoring: false },
  creative: { label: 'Creative', color: theme.colors.DRIFT, isMonitoring: false },
  curation: { label: 'Curation', color: theme.colors.SLATE, isMonitoring: false },
  'campaign-activation': { label: 'Campaign Activation', color: theme.colors.LUMO, isMonitoring: true },
  'performance-monitoring': { label: 'Performance Monitoring', color: theme.colors.GEO, isMonitoring: true },
  optimization: { label: 'Optimization', color: theme.colors.SLATE, isMonitoring: true },
  reporting: { label: 'Reporting', color: theme.colors.ALIGN, isMonitoring: true },
  database: { label: 'Database', color: theme.colors.STEM, isMonitoring: false },
  general: { label: 'General', color: theme.colors.TONE, isMonitoring: false },
  development: { label: 'Development', color: theme.colors.HALO, isMonitoring: false },
};

/**
 * Get the color for an agent type.
 * @param {string} type - The agent type key
 * @returns {string} The color value, or border color as fallback
 */
export const getAgentColor = (type) => {
  return AGENT_TYPE_CONFIG[type]?.color || theme.colors.border;
};

/**
 * Get the display label for an agent type.
 * @param {string} type - The agent type key
 * @returns {string} The formatted label
 */
export const getAgentLabel = (type) => {
  return AGENT_TYPE_CONFIG[type]?.label || formatAgentType(type);
};

/**
 * Check if an agent type is a monitoring type.
 * @param {string} type - The agent type key
 * @returns {boolean} True if monitoring type
 */
export const isMonitoringAgentType = (type) => {
  return AGENT_TYPE_CONFIG[type]?.isMonitoring || false;
};

/**
 * Get agent types as options array for dropdowns/selects.
 * @returns {Array<{value: string, label: string}>}
 */
export const getAgentTypeOptions = () => {
  return Object.entries(AGENT_TYPE_CONFIG).map(([value, config]) => ({
    value,
    label: config.label,
  }));
};

/**
 * Format an agent type string for display (fallback).
 * @param {string} value - The agent type key
 * @returns {string} Formatted string
 */
export const formatAgentType = (value) => {
  if (!value) {
    return '';
  }
  return String(value)
    .split('-')
    .filter(Boolean)
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join(' ');
};
